import { render, staticRenderFns } from "./PriceAnalysis.vue?vue&type=template&id=6d0aa91d"
import script from "./PriceAnalysis.vue?vue&type=script&lang=js"
export * from "./PriceAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports